import { components, GroupBase, SingleValueProps } from '@any-ui-react/select';

import { OptionContent } from './OptionContent';
import { getCountFromData } from './utils';

export const SingleValue = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
  data,
  withCounter,
  ...props
}: SingleValueProps<Option, IsMulti, Group> & { withCounter?: boolean }) => {
  const tagCount = getCountFromData(data);
  return (
    <components.SingleValue {...props} data={data}>
      <OptionContent tagCount={tagCount} withCounter={withCounter}>
        {children}
      </OptionContent>
    </components.SingleValue>
  );
};
